import { render, staticRenderFns } from "./Feature10.vue?vue&type=template&id=214833f8&"
import script from "./Feature10.vue?vue&type=script&lang=js&"
export * from "./Feature10.vue?vue&type=script&lang=js&"
import style0 from "./Feature10.vue?vue&type=style&index=0&id=214833f8&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports